/* ws-cart-addon.js — <ws-cart-addon> (cart-drawer add-on card). One job: add the card's variant
   through the ONE cart writer (assets/ws-cart.js — serialized, JSON-safe) and repaint the drawer from
   the response's own sections, so the drawer, subtotal and header bubble update together and the card
   disappears because Liquid no longer renders it. Errors render in the card in plain words (never a
   raw parser message — a Shopify challenge page or a 429 used to surface as "Unexpected token <").
   Loaded once from snippets/cart-drawer.liquid; the element is re-created on every drawer repaint. */
(function () {
  if (customElements.get('ws-cart-addon')) return;

  class WsCartAddon extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-ws-cart-addon-btn]');
      this.err = this.querySelector('.ws-cart-addon__error');
      this.busy = false;
      if (this.btn) this.btn.addEventListener('click', this.add.bind(this));
    }

    setBusy(on) {
      this.busy = on;
      if (!this.btn) return;
      this.btn.setAttribute('aria-disabled', on ? 'true' : 'false');
      const label = this.btn.querySelector('.ws-cart-addon__btn-label');
      const busy = this.btn.querySelector('.ws-cart-addon__btn-busy');
      if (label) label.hidden = on;
      if (busy) busy.hidden = !on;
    }

    showError(msg) {
      if (!this.err) return;
      this.err.textContent = msg || (window.WSCart && window.WSCart.GENERIC_ERROR) || 'Sorry, that did not go through. Please try again.';
      this.err.hidden = false;
    }

    add() {
      if (this.busy) return;
      if (window.WSCart && window.WSCart.busy()) return; // another write is in flight — the busy guard also hides the button
      const variantId = Number(this.dataset.variantId);
      if (!variantId) return this.showError();
      this.setBusy(true);
      if (this.err) this.err.hidden = true;

      const drawer = document.querySelector('cart-drawer');
      const sections = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map((s) => s.id)
        : ['cart-drawer', 'cart-icon-bubble'];

      const run = window.WSCart
        ? window.WSCart.add([{ id: variantId, quantity: 1 }], sections)
        : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sections.join(','), sections_url: location.pathname }) }).then((r) => r.json());

      run
        .then((json) => {
          if (drawer && typeof drawer.renderContents === 'function' && json.sections) {
            if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
            drawer.renderContents(json);
            /* No publish(cartUpdate): renderContents already repaints the drawer + bubble from this write's
               own sections. A publish made the drawer re-fetch and re-render a second time mid-interaction. */
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch((e) => {
          this.setBusy(false);
          this.showError(e && e.code === 'cart_error' ? e.message : undefined);
        });
    }
  }

  customElements.define('ws-cart-addon', WsCartAddon);
})();
